import { render, staticRenderFns } from "./ScatterChartView.vue?vue&type=template&id=40280447&scoped=true"
import script from "./ScatterChartView.vue?vue&type=script&lang=js"
export * from "./ScatterChartView.vue?vue&type=script&lang=js"
import style0 from "./ScatterChartView.vue?vue&type=style&index=0&id=40280447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40280447",
  null
  
)

export default component.exports